import { handleActions } from 'redux-actions';
import produce from 'immer';

const initialState = {
  isLoggedIn: false,
  id: null,
  role: null,
  menus: null,
  key: null,
  tmsUserRid: null,
};

export default handleActions(
  {
    'AUTH/LOGIN': (state, action) =>
      produce(state, (draft) => {
        const { id, role, menus, key, tmsUserRid } = action.payload;
        draft.isLoggedIn = true;
        draft.id = id;
        draft.key = key;
        draft.role = role;
        draft.menus = menus;
        draft.tmsUserRid = tmsUserRid;
      }),
    'AUTH/LOGOUT': (state, action) => initialState,
  },
  initialState
);
